import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import { t } from '../../../i18n'
import { CommandButton, ServiceSessionType } from '../types'
import { useCommandExecution } from '../CommandExecutionContext'
import { sessionBlockedText } from '../sessionTypes'

const scope = 'controls'

const tooltipFor = (command?: CommandButton, blockingSessionType?: ServiceSessionType | null): string => {
  if (!command || command.available) return ''
  if (blockingSessionType) return sessionBlockedText(blockingSessionType)
  if (command.requires_service_session) return t('session_only_tooltip', { scope })

  return ''
}

interface ActionButtonProps {
  command?: CommandButton
  className?: string
  style?: React.CSSProperties
  buttonClassName?: string
  icon?: React.ReactNode
  label?: React.ReactNode
  onClick?: () => void
  busy?: boolean
  disabled?: boolean
  tooltip?: string
}

const ActionButton = ({ command, className, style, buttonClassName, icon, label, onClick, busy, disabled, tooltip }: ActionButtonProps) => {
  const { requestCommand, isBusy, blockingSessionType, canExecute } = useCommandExecution()
  if (!canExecute) return null

  const isBusyState = busy ?? (command ? isBusy(command.name) : false)
  const isDisabled = disabled ?? ((command ? !command.available : false) || isBusyState)
  const tooltipText = tooltip ?? tooltipFor(command, blockingSessionType)
  const handleClick = onClick ?? (command ? () => requestCommand(command) : undefined)

  return (
    <Tooltip title={tooltipText} placement="top" arrow>
      <span className={`d-block ${className ?? ''}`} style={style}>
        <button
          type="button"
          className={buttonClassName ?? 'btn btn-secondary w-100 h-100'}
          onClick={handleClick}
          disabled={isDisabled}
        >
          {icon}
          {label ?? command?.human_name}
          {isBusyState && <span className="spinner-border spinner-border-sm ms-2" />}
        </button>
      </span>
    </Tooltip>
  )
}

export default ActionButton
